import { c as _c } from "react/compiler-runtime";
import type { Hex } from 'viem';
import { type ChainId, ChainUtils } from '@morpho-org/blue-sdk';
import { ExternalLink } from '@morpho-org/ui-v6/server';
import { cn } from '@morpho-org/ui-v6/utils';
import { abbreviateAddress } from '@repo/utils';
import { useMemo } from 'react';
export interface ExplorerUrlProps {
  txHash?: Hex;
  chainId?: ChainId;
  className?: string;
}
const ExplorerUrl = t0 => {
  const $ = _c(13);
  const {
    txHash,
    chainId,
    className
  } = t0;
  let t1;
  bb0: {
    if (!chainId || !txHash) {
      t1 = undefined;
      break bb0;
    }
    let t2;
    if ($[0] !== chainId || $[1] !== txHash) {
      t2 = ChainUtils.getExplorerTransactionUrl(chainId, txHash);
      $[0] = chainId;
      $[1] = txHash;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = t2;
  }
  const href = t1;
  if (!txHash || !chainId || !href) {
    return null;
  }
  let t2;
  if ($[3] !== className) {
    t2 = cn("text-2xs", className);
    $[3] = className;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== txHash) {
    t3 = abbreviateAddress(txHash);
    $[5] = txHash;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <span className={t2}>{t3}</span>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== href || $[11] !== t4) {
    t5 = <ExternalLink href={href} underlined={true}>{t4}</ExternalLink>;
    $[10] = href;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default ExplorerUrl;